import * as THREE from 'three';

/**
 * Custom Three.js geometry for rendering capsule shapes.
 * Used for rendering MuJoCo capsule geometries in the simulation.
 * backport of CapsuleGeometry class introduced in THREE.js r139
 */
export class CapsuleGeometry extends THREE.BufferGeometry {
  readonly parameters: {
    readonly radius: number;
    readonly length: number;
    readonly capSegments: number;
    readonly radialSegments: number;
  };

  constructor(radius = 1, length = 1, capSegments = 4, radialSegments = 8) {
    const path = new THREE.Path();
    path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0, false);
    path.absarc(0, length / 2, radius, 0, Math.PI * 0.5, false);
    const latheGeometry = new THREE.LatheGeometry(path.getPoints(capSegments), radialSegments);

    super();
    this.setIndex(latheGeometry.getIndex());
    this.setAttribute('position', latheGeometry.getAttribute('position'));
    this.setAttribute('normal', latheGeometry.getAttribute('normal'));
    this.setAttribute('uv', latheGeometry.getAttribute('uv'));

    this.parameters = {
      radius,
      length,
      capSegments,
      radialSegments,
    };
  }
}
